module.exports = __webpack_public_path__ + "static/media/lookup.bf5d651b.svg";